export const categories = [
  {
    id: "public_employee",
    label: "Dipendente pubblico",
  },
  {
    id: "private_employee",
    label: "Dipendente privato",
  },
  {
    id: "retired",
    label: "Pensionato",
  },
  {
    id: "military",
    label: "Militare / Parastatale",
  },
  {
    id: "iva",
    label: "Partita IVA",
  },
  {
    id: "baby_sitter",
    label: "Baby sitter / Casalinga",
  },
  {
    id: "not_employee",
    label: "Disoccupato",
  },
];
